module.exports = __webpack_public_path__ + "media/images/logo-38251dad6ccd719512fc0546a7f14731.png";